module.exports = __webpack_public_path__ + "img/button-hardware.945afa77.svg";